import React from 'react';
import PropTypes from 'prop-types';

import SessionSearchBanner from '../../../Base/Banner/SessionSearchBanner';
import BuyingProcess from '../index';

const SessionLayout = ({ children }) => (
  <BuyingProcess>
    <SessionSearchBanner />
    {children}
  </BuyingProcess>
);

SessionLayout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SessionLayout;
